import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frequency", "hour", "minute", "dayOfWeek", "dayOfMonth", "cronExpression", "timeFields", "weekFields", "monthFields"]

  connect() {
    // Initialize cron expression on connect
    setTimeout(() => {
      this.toggleFields()
      this.updateCronExpression()
    }, 100)
  }

  toggleFields() {
    if (!this.hasFrequencyTarget) {
      console.warn('[Schedule Builder] Frequency target not found')
      return
    }
    const frequency = this.frequencyTarget.value
    
    // Hide all conditional fields first
    if (this.hasTimeFieldsTarget) this.timeFieldsTarget.classList.add('hidden')
    if (this.hasWeekFieldsTarget) this.weekFieldsTarget.classList.add('hidden')
    if (this.hasMonthFieldsTarget) this.monthFieldsTarget.classList.add('hidden')
    
    // Show relevant fields based on frequency
    switch(frequency) {
      case 'daily':
        if (this.hasTimeFieldsTarget) this.timeFieldsTarget.classList.remove('hidden')
        break
      case 'weekly':
        if (this.hasTimeFieldsTarget) this.timeFieldsTarget.classList.remove('hidden')
        if (this.hasWeekFieldsTarget) this.weekFieldsTarget.classList.remove('hidden')
        break
      case 'monthly':
        if (this.hasTimeFieldsTarget) this.timeFieldsTarget.classList.remove('hidden')
        if (this.hasMonthFieldsTarget) this.monthFieldsTarget.classList.remove('hidden')
        break
    }
    
    this.updateCronExpression()
  }

  updateCronExpression() {
    if (!this.hasFrequencyTarget) {
      console.warn('[Schedule Builder] Cannot update cron - frequency target not found')
      return
    }
    
    const frequency = this.frequencyTarget.value
    let cron = ''
    
    const minute = this.hasMinuteTarget ? (this.minuteTarget.value || '0') : '0'
    const hour = this.hasHourTarget ? (this.hourTarget.value || '0') : '0'
    const dayOfWeek = this.hasDayOfWeekTarget ? (this.dayOfWeekTarget.value || '0') : '0'
    const dayOfMonth = this.hasDayOfMonthTarget ? (this.dayOfMonthTarget.value || '1') : '1'
    
    switch(frequency) {
      case 'every_5_minutes':
        cron = '*/5 * * * *'
        break
      case 'every_15_minutes':
        cron = '*/15 * * * *'
        break
      case 'every_30_minutes':
        cron = '*/30 * * * *'
        break
      case 'hourly':
        cron = `${minute} * * * *`
        break
      case 'daily':
        cron = `${minute} ${hour} * * *`
        break
      case 'weekly':
        cron = `${minute} ${hour} * * ${dayOfWeek}`
        break
      case 'monthly':
        cron = `${minute} ${hour} ${dayOfMonth} * *`
        break
    }
    
    if (this.hasCronExpressionTarget) {
      this.cronExpressionTarget.value = cron
    }
    
    // Update the display
    const display = document.getElementById('cron-display')
    if (display) {
      display.textContent = cron
    }
  }
}

